import React, { useState } from 'react';

import { IPlanStartingPeriod } from '@leedpulse-monorepo/interfaces';
import { Button, Flex, Form, InputNumber, Popconfirm, Typography } from 'antd';
import { DeleteOutlined, PlusOutlined } from '@ant-design/icons';
import LeedbucksRatesList from '../LeedbucksRatesList/LeedbucksRatesList';

interface LeedbucksStartingPeriodProps {
    period?: IPlanStartingPeriod;
    planLeedbucks?: number; // the plan's own allocation, for the explanation
    onChange?: (period: IPlanStartingPeriod | undefined) => void;
    isReadOnly?: boolean;
}

export default function LeedbucksStartingPeriod({ period, planLeedbucks = 0, onChange, isReadOnly = false }: LeedbucksStartingPeriodProps) {
    const [newDuration, setNewDuration] = useState<number | null>(null);

    if (!period) {
        return isReadOnly
            ? <Typography.Text type="secondary">Aucune période de démarrage</Typography.Text>
            : <Flex gap={8} align="center">
                <InputNumber min={1} precision={0} value={newDuration} onChange={setNewDuration} addonAfter="jours" placeholder="Durée" />
                <Button
                    type="primary"
                    icon={<PlusOutlined />}
                    disabled={!newDuration}
                    onClick={() => newDuration && onChange?.({ duration_days: newDuration, rates: {} })}
                >
                    Ajouter une période
                </Button>
            </Flex>;
    }

    return <Flex vertical gap={8}>
        <Typography.Text type="secondary">
            Copiée sur chaque nouvel abonnement du plan : pendant {period.duration_days} jours à partir de son démarrage, recalés sur sa date d'onboarding, il reçoit ces crédits à chaque recharge à la place des {planLeedbucks} du plan, et ces taux. Les abonnements déjà créés gardent la période qu'ils ont reçue.
        </Typography.Text>
        <Flex gap={8} align="flex-end" justify="space-between" wrap="wrap">
            <Flex gap={8} align="flex-end" wrap="wrap">
                <Form.Item label="Durée" style={{ marginBottom: 0 }}>
                    <InputNumber min={1} precision={0} value={period.duration_days} onChange={(days) => days && onChange?.({ ...period, duration_days: days })} disabled={isReadOnly} addonAfter="jours" />
                </Form.Item>
                <Form.Item label="Crédits par recharge" style={{ marginBottom: 0 }}>
                    <InputNumber
                        min={0}
                        precision={0}
                        value={period.leedbucks ?? null}
                        onChange={(leedbucks) => onChange?.(leedbucks == null ? { duration_days: period.duration_days, rates: period.rates } : { ...period, leedbucks })}
                        disabled={isReadOnly}
                        addonAfter="leedbucks"
                        placeholder="Ceux du plan"
                    />
                </Form.Item>
            </Flex>
            {!isReadOnly && <Popconfirm
                title="Supprimer la période de démarrage ?"
                okText="Supprimer"
                cancelText="Annuler"
                okButtonProps={{ danger: true }}
                onConfirm={() => onChange?.(undefined)}
            >
                <Button danger icon={<DeleteOutlined />}>Supprimer la période</Button>
            </Popconfirm>}
        </Flex>
        <LeedbucksRatesList
            rates={period.rates}
            onChange={(rates) => onChange?.({ ...period, rates })}
            isReadOnly={isReadOnly}
            canManageRows
        />
    </Flex>;
}